/**
 * This script forces a complete reset of all Firebase connections.
 * Run this once when you need to reset everything after updating configuration.
 */

import { forceNetworkReset } from './firebase.js';

/**
 * Forces a complete reset of all Firebase connections
 * Use this function after updating Firebase configuration
 * @returns {Promise<boolean>} Success status
 */
export async function resetAllFirebaseConnections() {
  console.log('🔄 Starting Firebase connection reset...');
  
  // Step 1: Clear local storage related to Firebase/Firestore
  try {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.includes('firebase') || 
          key.includes('firestore') || 
          key.includes('fs_uid')) {
        keysToRemove.push(key);
      }
    }
    
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
      console.log(`🗑️ Removed from localStorage: ${key}`);
    });
  } catch (error) {
    console.error('Error clearing localStorage:', error);
  }
  
  // Step 2: Clear IndexedDB databases
  if (window.indexedDB) {
    try {
      const databases = await window.indexedDB.databases();
      const firebaseDbs = databases.filter(db => 
        db.name.includes('firebase') || 
        db.name.includes('firestore')
      );
      
      for (const db of firebaseDbs) {
        try {
          await window.indexedDB.deleteDatabase(db.name);
          console.log(`🗑️ Deleted IndexedDB database: ${db.name}`);
        } catch (dbError) {
          console.error(`Error deleting IndexedDB ${db.name}:`, dbError);
        }
      }
    } catch (indexedDBError) {
      console.error('Error listing IndexedDB databases:', indexedDBError);
    }
  }
  
  // Step 3: Force network reset
  const success = await forceNetworkReset();
  
  if (success) {
    console.log('✅ Firebase reset complete! Refresh the page to reconnect with clean state.');
    return true;
  } else {
    console.error('❌ Firebase reset failed. Please try refreshing the page manually.');
    return false;
  }
}

/**
 * Convenience function to reload the page
 */
export function reloadPage() {
  window.location.reload();
}

console.log("💡 Firebase reset module loaded! To reset all connections, run:");
console.log("import('./forceReset.js').then(module => module.resetAllFirebaseConnections())"); 